exports.components = {
  "component---src-pages-hello-reusably-tsx": () => import("./../../../src/pages/hello-reusably.tsx" /* webpackChunkName: "component---src-pages-hello-reusably-tsx" */),
  "component---src-pages-open-app-tsx": () => import("./../../../src/pages/open-app.tsx" /* webpackChunkName: "component---src-pages-open-app-tsx" */),
  "component---src-pages-open-promo-tsx": () => import("./../../../src/pages/open-promo.tsx" /* webpackChunkName: "component---src-pages-open-promo-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */)
}

